import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCheckInStatusEnum as CheckInStatusEnum,
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  combineJourneyTravelers,
  createAcceptance,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  MockAcceptance,
  MockJourneyElementCommon,
  RecursivePartial,
} from '@dapi/sdk/spec';
import {
  authorization,
} from '../../mock';
import {
  chargeableSeatsToPayForTwoPax,
  createSeatmapMockData,
  defaultCheckInBaggagePolicies,
  firstCHSeatOnJourney,
  firstFreeSeatOnJourney,
  noItemToPayError,
  paymentRecords,
  seatAvailabilityOverrides,
  secondCHSeatOnJourney,
} from '../../mock/data';

/**
 * OW 1Journey
 * 3ADT
 * Chargeable seats journey
 * pay for unpaid services
 */

const Travelers = combineJourneyTravelers([JourneyTravelerRepository.MAN, JourneyTravelerRepository.WOMAN, JourneyTravelerRepository.MAN], {}).items;
const journeyTemplate: RecursivePartial<Journey> = {
  travelers: Travelers
};

const journeys = combineJourneys([journeyTemplate]).items;
const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);
export const {seatmap} = createSeatmapMockData(journeys, seatAvailabilityOverrides);

const checkedInJourneyElementFirstSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: firstCHSeatOnJourney[0],
        checkInStatus: 'accepted',
        traveler: Travelers[0],
        travelerId: Travelers[0].id
      }
    })
  }
});

const checkedInJourneyElementSecondSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: {
          ...secondCHSeatOnJourney[0],
          travelers: [Travelers[1]]
        },
        checkInStatus: 'accepted',
        traveler: Travelers[1],
        travelerId: Travelers[1].id,
        id: Travelers[1].id
      }
    }),
    id: Travelers[1].id
  }
});

const checkedInJourneyElementThirdSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: firstFreeSeatOnJourney[0],
        checkInStatus: 'accepted',
        traveler: Travelers[2],
        travelerId: Travelers[2].id
      }
    }),
    id: Travelers[2].id
  }
});

const acceptance: MockAcceptance = createAcceptance({
  template: {
    checkedInJourneyElements: [checkedInJourneyElementFirstSeat, checkedInJourneyElementSecondSeat, checkedInJourneyElementThirdSeat],
    isAccepted: true
  }
});

const checkInStatus: CheckInStatusEnum = 'accepted';

export const ow1Journey3AdtChargeableSeatsUnpaidPayment: MockMap = {
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(chargeableSeatsToPayForTwoPax),
    createMockData(noItemToPayError),
    createMockData(chargeableSeatsToPayForTwoPax),
    createMockData(chargeableSeatsToPayForTwoPax),
    createMockData(chargeableSeatsToPayForTwoPax),
    createMockData(chargeableSeatsToPayForTwoPax),
    createMockData(chargeableSeatsToPayForTwoPax),
    createMockData(noItemToPayError),
    createMockData(noItemToPayError)
  ],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstCHSeatOnJourney[0], 201), createMockDataWithResponse({
      ...secondCHSeatOnJourney[0],
      journeyElementId: Travelers[1].id
    }, 201)
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(acceptance, 201), createMockDataWithResponse(acceptance, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([{
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED,
      journeyElements: journeys[0].journeyElements.map((je) => ({
        ...je,
        journeyElement: {
          ...je.journeyElement,
          checkInStatus
        }
      }))
    }], 201)],
  retrieveJourney: [
    createMockData({
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    })
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  updateJourneySeats: [
    createMockData(firstCHSeatOnJourney[0]), createMockData({
      ...secondCHSeatOnJourney[0],
      journeyElementId: Travelers[1].id
    })
  ],
  updateJourneyElement: [
    createMockData(firstCHSeatOnJourney[0]), createMockData({
      ...secondCHSeatOnJourney[0],
      journeyElementId: Travelers[1].id
    })
  ]
};
